import { render, staticRenderFns } from "./landFilterCom.vue?vue&type=template&id=31fc8f04&scoped=true&"
import script from "./landFilterCom.vue?vue&type=script&lang=js&"
export * from "./landFilterCom.vue?vue&type=script&lang=js&"
import style0 from "./landFilterCom.vue?vue&type=style&index=0&id=31fc8f04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fc8f04",
  null
  
)

export default component.exports